'use client';
import { Cimage } from '@/components/ui/Cimage';
import { Cmembericon } from '@/components/ui/Cmembericon';
import { TeamRole } from '@cabal/shared/domain/session/team/enums.js';
import { getProviderIconPath } from '@/variety/llmProviders';
import type { ReactElement } from 'react';
interface FakeCommentIconColumnProps {
    role: TeamRole;
    provider?: string;
    memberColor: string;
    isMobile: boolean;
}
export function FakeCommentIconColumn({ role, provider, memberColor, isMobile, }: FakeCommentIconColumnProps): ReactElement {
    const operativeContent = role === TeamRole.Operative && provider ? (<Cimage src={getProviderIconPath(provider)} alt={provider} static={true} objectFit="contain" style={{
            width: '70%',
            height: '70%',
        }}/>) : undefined;
    return <div style={{
            display: 'flex',
            flexDirection: isMobile ? 'row' : 'column',
            flexShrink: 0,
        }}>
            <Cmembericon dataElScope="Cfakecomment/FakeCommentIconColumn" role={role} content={operativeContent} colorHex={memberColor} size={isMobile ? 26 : 52} radius={isMobile ? 10 : 20}/>
        </div>
        ;
}
